import { render, staticRenderFns } from "./customer1.vue?vue&type=template&id=dc9ce2bc&scoped=true"
import script from "./customer1.vue?vue&type=script&lang=js"
export * from "./customer1.vue?vue&type=script&lang=js"
import style0 from "./customer1.vue?vue&type=style&index=0&id=dc9ce2bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9ce2bc",
  null
  
)

export default component.exports